import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import Button from '@amzn/meridian/button';
import Checkbox from '@amzn/meridian/checkbox';
import Divider from '@amzn/meridian/divider';
import Input from '@amzn/meridian/input';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import LoadingSpinnerWrapper from 'src/components/shared/loadingSpinner/loadingSpinnerWrapper';
import { AdminConfigPaths } from 'src/store/adminConfigPageSlice/common/constants';
import {
  fetchRegionTasksById,
  resetSeletedRegion,
  setSelectedRegion,
  updateRegionTasks,
  updateRestrictionForm,
} from 'src/store/adminConfigPageSlice/regionTasksPageSlice/regionTasksPageSlice';
import { getModifications } from 'src/store/modificationsSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';

import './formTaskConfiguration.scss';

import AssignModificationsModal from './formTasksTable/assignModificationsModal';
import FormTasksTable from './formTasksTable/formTasksTable';

// **** Constants **** //

const ROW_HEIGHT = '50px';
const INPUT_FIELD_LAYOUT = ['grid-2', 'grid-2'];

// **** Components **** //

/**
 * Default component
 */
const FormTaskConfiguration = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { selectedRegion, selectedRegionTasks } = useAppSelector((state) => state.regionTasksConfigPage);
  const [showSpinner, setShowSpinner] = useState(false);

  // Fetch data and show spinner
  const fetchIOData = async () => {
    setShowSpinner(true);
    await dispatch(fetchRegionTasksById(selectedRegion.id));
    setShowSpinner(false);
    dispatch(getModifications());
  };

  // Fetch IO data when page loads
  useEffect(() => {
    if (selectedRegion.id) {
      fetchIOData();
    }
  }, [selectedRegion.id]);

  return (
    <div data-testid="form-task-config-panel" className="view-and-edit-forms">
      {/* Save/Cancel buttons */}
      <Row widths={['grid-11', 'grid-1']} height={ROW_HEIGHT}>
        <Row spacingInset="none none none 300">
          <Button
            size="small"
            type="secondary"
            onClick={() => {
              dispatch(resetSeletedRegion());
              navigate(AdminConfigPaths.Form.TABLE, { replace: true });
            }}
          >
            Cancel
          </Button>
        </Row>
        <Row alignmentHorizontal="end" spacingInset="none 300 none none">
          <Button
            size="small"
            onClick={() => {
              dispatch(updateRestrictionForm(selectedRegion));
              dispatch(updateRegionTasks(selectedRegionTasks));
            }}
          >
            Save
          </Button>
        </Row>
      </Row>
      <Divider spacingAfter="500" />

      {/* Form Body */}
      <Row widths={INPUT_FIELD_LAYOUT} height={ROW_HEIGHT}>
        <Text>Restriction Form Name</Text>
        <Input
          type="text"
          placeholder="Enter form name..."
          value={selectedRegion.formName}
          aria-label="Restriction Form Name"
          onChange={(name) => {
            dispatch(setSelectedRegion({ ...selectedRegion, formName: name }));
          }}
        />
      </Row>
      <Row widths={INPUT_FIELD_LAYOUT} height={ROW_HEIGHT}>
        <Text>Country</Text>
        <Text>{selectedRegion.country}</Text>
      </Row>
      <Row widths={INPUT_FIELD_LAYOUT} height={ROW_HEIGHT}>
        <Text>Region/State/Province</Text>
        <Text>{selectedRegion.name}</Text>
      </Row>
      <Row widths={INPUT_FIELD_LAYOUT} height={ROW_HEIGHT}>
        <Text>Description</Text>
        <Input
          type="text"
          placeholder="Enter description..."
          aria-label="Description"
          value={selectedRegion.description}
          onChange={(description) => dispatch(setSelectedRegion({ ...selectedRegion, description: description }))}
        />
      </Row>
      <Row widths={INPUT_FIELD_LAYOUT} height={ROW_HEIGHT}>
        <Text>Is Active?</Text>
        <Checkbox
          checked={selectedRegion.isActive}
          aria-label="Is Active?"
          onChange={(isActive) => dispatch(setSelectedRegion({ ...selectedRegion, isActive: isActive }))}
        />
      </Row>
      <Divider spacingBefore="500" spacingAfter="450" />

      {/* Table */}
      <LoadingSpinnerWrapper showSpinner={showSpinner}>
        <FormTasksTable />
      </LoadingSpinnerWrapper>
      <AssignModificationsModal />
    </div>
  );
};

// **** Export **** //

export default FormTaskConfiguration;
